import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import EnumFilteredDropdown from 'components/EnumFilteredDropdown';
import enumCollections from 'constants/enumCollections';
import { DEFAULT_TITLE, getReadableTitle } from './helpers';
var FacilityTypeDropdown = function (_a) {
    var _b;
    var defaultValue = _a.defaultValue, onSave = _a.onSave, _c = _a.dataTest, dataTest = _c === void 0 ? 'FacilityTypeDropdown' : _c;
    var values = ((_b = enumCollections === null || enumCollections === void 0 ? void 0 : enumCollections.FACILITY_LOCATION_TYPE) === null || _b === void 0 ? void 0 : _b.enumValues) || [];
    var items = values.map(function (i) { return ({
        label: i.description,
        value: i.name
    }); });
    return (_jsx(EnumFilteredDropdown, { defaultValue: defaultValue, defaultTitle: DEFAULT_TITLE, getReadableTitle: getReadableTitle, items: items, onSave: onSave, dataTest: dataTest }));
};
export default FacilityTypeDropdown;
